import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {SecondaryValue} from './secondary-value';
import type {SecondaryValueType} from './secondary-value';

import styles from './metrics.module.css';

type Props = {
    value: React.ReactNode;
    clickingNavigatesTo: string;
    secondaryValue?: SecondaryValueType;
};

export function ClickableStat(props: Props) {
    return (
        // @ts-expect-error
        <RouterLink to={props.clickingNavigatesTo} className={styles['clickable-stat']}>
            <div
                className={
                    props.secondaryValue ? styles['stat-value'] : styles['underline-stat-value']
                }
            >
                {props.value}
            </div>
            {props.secondaryValue && <SecondaryValue secondaryValue={props.secondaryValue} />}
        </RouterLink>
    );
}
